module.exports = __webpack_public_path__ + "img/blank1.23024cc1.svg";